import { Box, Paper, Typography } from '@mui/material'
import { useAppTheme } from '@/theme/ThemeContext'

// Format number — always show 2 decimal places
const formatNumber = (value: number | string): string => {
  const num = typeof value === 'string' ? parseFloat(value) : value
  if (isNaN(num)) return String(value)
  return num.toLocaleString('he-IL', { minimumFractionDigits: 2, maximumFractionDigits: 6 })
}

export default function KPIWidgetResult({
                                          title,
                                          value,
                                          unit = 'קוב',
                                          dateRangeText,
                                          blue = false,
                                        }: {
  title: string
  value: number | string
  unit?: string
  dateRangeText?: string
  blue?: boolean
}) {
  const { mode } = useAppTheme()
  const isDarkMode = mode === 'dark'

  const colors = {
    bg: isDarkMode ? '#162645' : '#FFFFFF',
    border: isDarkMode ? '#445876' : '#E6ECF2',
    valueText: isDarkMode ? '#fff' : '#003F61',
    unitText: isDarkMode ? '#93A3B5' : '#6B829E',
    titleText: isDarkMode ? '#B0BEC5' : '#0F3E66',
    dateText: isDarkMode ? '#6B7A8C' : '#8F98A5',
  }

  // Format the display value
  const displayValue = formatNumber(value)
  return (
      <Paper
        elevation={0}
        sx={{
          flex: 1,
          borderRadius: 2,
          px: { xs: 2, lg: 1.25, xl: 1.5 },
          py: 1,
          border: `1px solid ${colors.border}`,
          bgcolor: colors.bg,
        }}
        dir="rtl"
      >
        <Box sx={{ display: 'flex', alignItems: 'baseline', gap: 1 }}>
          <Typography
            sx={{
              color: colors.valueText,
              fontWeight: 700,
              fontSize: { xs: '29.84px', lg: '20px', xl: '24px' },
              fontFamily: 'Rubik, sans-serif',
            }}
          >
            {displayValue}
          </Typography>
          <Typography sx={{ color: colors.unitText, fontFamily: 'Rubik, sans-serif' }}>
            {unit}
          </Typography>
        </Box>

        <Box sx={{ display: 'flex', alignItems: 'center', gap: 1, overflow: 'hidden', flexWrap: 'nowrap' }}>
          <Typography
            sx={{
              color: colors.titleText,
              fontWeight: 700,
              fontSize: '13px',
              fontFamily: 'Rubik, sans-serif',
              whiteSpace: 'nowrap',
              flexShrink: 0,
            }}
          >
            {title}
          </Typography>
          <Box
            sx={{
              width: 8,
              height: 8,
              borderRadius: '50%',
              bgcolor: blue ? '#254D88' : '#B3E084',
              flexShrink: 0,
            }}
          />
          {dateRangeText && (
            <Typography
              sx={{
                color: colors.dateText,
                fontSize: '10px',
                fontFamily: 'Rubik, sans-serif',
                whiteSpace: 'nowrap',
                flexShrink: 0,
              }}
            >
              {dateRangeText}
            </Typography>
          )}
        </Box>
      </Paper>
  )
}
